import React from 'react';
import {Col,Row,Form} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import {RootURL} from '../../Utils/Function';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';
const Login =()=> {
    const { register, handleSubmit, watch, reset, getValues,setValue, control, formState: { errors } } = useForm();

    const _Login=()=>{
        API({method : "post",url:"/Authorization/Staff/Login",data:{UserName : getValues("UserName"),Password : getValues("Password")}, headers: { "Content-Type": "multipart/form-data" }}).then(res=>{
            if (res.status !== 200) {
                Swal.fire({
                    icon: 'error',
                    title: 'การเชื่อมต่อผิดพลาด',
                    text: res.data.Message,
                });
                return;
            }

            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message,
                });
                return;
            }
            let _redirect = localStorage.getItem('redirect');
            localStorage.clear();
            localStorage.setItem("Authorization", res.data.Data.accesstoken);

            localStorage.setItem("UserID", res.data.Data.userid);
            localStorage.setItem("Name", res.data.Data.name);
            localStorage.setItem("Role", res.data.Data.role);
            

            switch(res.data.Data.role){
                case 2 : 
                    window.location =RootURL()+'/Store';
                break;
                case 3 :
                    window.location =RootURL()+'/Staff';
                break;
                case 9:
                    window.location =RootURL()+'/Admin';
                break;
                default:
                    window.location =RootURL()+'/Staff';
                break;
            }
                

        }).catch(res => {
            Swal.fire({
                icon: 'error',
                title: 'การเชื่อมต่อผิดพลาด',
                text: res.message+' ['+res.code+']',
            })
        });
    }
    return (
        <>
        <section className='sign-in-page h-100'>
            <div className='container-fluid min-vh-100 d-flex align-items-center justify-content-center'>
                <div className='no-gutters d-flex justify-content-center'>
                    <Col lg={12} col={8} sm={10} xs={10} className='align-self-center  mt-5 mb-5 login-box'>
                        <Form onSubmit={handleSubmit(_Login)}>
                            <div className='sign-in-from ml-4 mr-4 mt-4 mb-4'>
                                <div className='row'>
                                    <div className='col-12 text-center'>
                                        <img src={require('../../Assets/Images/Logo/TALFC_Logo.png')}/>
                                    </div>
                                </div>
                                <div className='row justify-content-md-center mt-2'>
                                    <div className='col-8'>
                                        <div className="mb-3">
                                            <label htmlFor="Username" className="form-label text-white">ชื่อผู้ใช้งาน</label>
                                            <Controller name="UserName" control={control} rules={{required:true}} render={({field})=>(
                                                <input autoFocus type="text" id="Username" className="form-control" value={field.value} aria-describedby={field.name} placeholder="Username" autoComplete="off" onChange={(e)=>field.onChange(e)} defaultValue={field.value} />
                                            )} />
                                            {errors.UserName && errors.UserName.type == 'required' && <small className="form-text alert alert-danger">โปรดตรวจสอบ Username</small> }
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="Passwprd" className="form-label text-white">รหัสผ่าน</label>
                                            <Controller name="Password" control={control} rules={{required:true}} render={({field})=>(
                                                <input type="password" className="form-control" value={field.value} aria-describedby={field.name} placeholder="Password" autoComplete="off" onChange={(e)=>field.onChange(e)} defaultValue={field.value} />
                                            )} />
                                            {errors.Password && errors.Password.type == 'required' && <small className="form-text alert alert-danger">โปรดตรวจสอบ Password</small> }
                                        </div>
                                    </div>
                                </div>
                                <div className='row justify-content-md-center mt-4 mb-5'>
                                    <div className='col-8 text-center'>
                                        <button type='submit' className='btn btn-lg btn-success'>เข้าสู่ระบบ</button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </Col>
                </div>
            </div>
        </section>
        </>
    )
}

export default React.memo(Login)
